import { reactive } from "vue";
import { useDebounceFn } from "@vueuse/core";
import { useCookies } from "@vueuse/integrations/useCookies";
import type { DataTableSortOrder } from "@cybersentriq/frontend-component-library/dist/types/src/components/data-table/types";

import { COOKIE_SETTINGS } from "@/utils/cookies";

export const useCookiesDataTable = (
  {
    sortByKey,
    sortOrdKey,
    rowsPerPageKey,
    selectedColumnsKey,
  }: {
    sortByKey: string;
    sortOrdKey: string;
    rowsPerPageKey: string;
    selectedColumnsKey: string;
  },
  defaults: Record<string, unknown>,
) => {
  const DEFAULTS = {
    sortBy: "created_at",
    sortOrd: "desc",
    rowsPerPage: 10,
    selectedColumns: [],
    ...defaults,
  };

  const cookies = useCookies();

  const sortBy = cookies.get(sortByKey) || DEFAULTS.sortBy;
  const sortOrd = cookies.get(sortOrdKey) || DEFAULTS.sortOrd;
  const rowsPerPage = cookies.get(rowsPerPageKey) || DEFAULTS.rowsPerPage;
  const selectedColumns =
    cookies.get(selectedColumnsKey) || DEFAULTS.selectedColumns;

  const reqParams = reactive({
    sortKey: sortBy,
    sortDir: String(sortOrd).toUpperCase() as DataTableSortOrder,
    results: rowsPerPage,
    page: 1,
    filter: "",
  });

  const setSort = (by: unknown, order: unknown) => {
    cookies.set(sortByKey, by, COOKIE_SETTINGS);
    cookies.set(sortOrdKey, order, COOKIE_SETTINGS);

    reqParams.sortKey = by;
    reqParams.sortDir = String(order).toUpperCase() as DataTableSortOrder;
  };

  const setRowsPerPage = (val: unknown) => {
    cookies.set(rowsPerPageKey, val, COOKIE_SETTINGS);

    reqParams.results = val;
    reqParams.page = 1;
  };

  const setPage = (val: number) => {
    reqParams.page = val;
  };

  const setSelectedColumns = (val: unknown) => {
    cookies.set(selectedColumnsKey, val, COOKIE_SETTINGS);
  };

  const search = (phrase: string) => {
    reqParams.filter = phrase;
    reqParams.page = 1;
  };

  const debouncedSearch = useDebounceFn((phrase) => {
    search(phrase);
  }, 500);

  return {
    reqParams,
    sortBy,
    sortOrd,
    rowsPerPage,
    selectedColumns,
    setSort,
    setRowsPerPage,
    setSelectedColumns,
    setPage,
    debouncedSearch,
  };
};

export default {};
